const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.interceptors.request.use(function(config) {
  config.headers.Authorization = localStorage.getItem("Token") || "";
  config.headers.Lang =
    localStorage.getItem("setlanguage") ||
    localStorage.getItem("detectedLanguage") ||
    "en";
  return config;
});
const state = {
  userupdatestatus: ""
};
const getters = {
  updateStatus: state => state.userupdatestatus
};
const mutations = {
  userupdate_request(state) {
    state.userupdatestatus = "loading";
  },
  userupdate_success(state, payload, root) {
    state.userupdatestatus = "success";
  },
  userupdate_error(state) {
    state.userupdatestatus = "error";
  }
};
const actions = {
  updateUser({ commit, dispatch }, userData) {
    if (userData.FirstName != "" && userData.LastName != "") {
      userData.FullName = [userData.FirstName, userData.LastName].join(" ");
    }
    return new Promise((resolve, reject) => {
      commit("userupdate_request");
      console.log({ userData });
      axios
        .post("/user", userData)
        .then(resp => {
          console.log({ resp });
          if (resp.data.UserSignIn) {
            const user = resp.data.UserSignIn;
            const token = user.Token;
            commit("userupdate_success");
            commit("auth_success", { token, user });
            resolve("ok");
          } else {
            commit("userupdate_success", resp.data);
            commit("setFullName", resp.data.FullName);
            commit("auth_success", {
              token: localStorage.getItem("Token"),
              user: resp.data
            });

            console.log(resp.data);
            // dispatch("updateLanguage", resp.data.Lang).then(() => {
            //   this.$root.up
            // });

            resolve("ok");
          }
        })
        .catch(err => {
          console.log({ err });
          commit("userupdate_error");
          reject(err);
        });
    });
  },



  
  // MANAGE FEEDS
  // GET ALL THE FEEDS
    GET_ALL_FEEDS_FOR_USER({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get("URL").then(response => {
          resolve(response.data);
        });
      });
    },
  // POST/UPDATE - Post or submit feed changes
  SUBMIT_FEEDS_UPDATE({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("URL", data).then(response => {
        resolve();
      })
      .catch(err => reject(err));
    });
  },
  // DELETE -feed
  DELETE_FEED({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.delete("URL/?id=" + id).then(response => {
        resolve();
      });
    });
  },
  // MANAGE FEEDS END




  GET_ARTICLE({ commit }, articleid) {
    articleid = articleid ? articleid : "blank";
    return new Promise((resolve, reject) => {
      axios
        .get(`/articles/${articleid}`)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  SUBMIT_ARTICLE({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/articles", articleData)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  DELETE_ARTICLE({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/articles", { params: { id: articleData.id } })
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  GET_ARTICLES({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      axios
        .get("/articles")
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          console.log({ err });
          reject(err);
        });
    });
  },
  UPDATE_TAGPROFILES({ commit }, TagProfileData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/tagprofile", TagProfileData)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          console.log({ err });
          reject(err);
        });
    });
  },
  // SAVE_TAG_PROFILE({ commit }, tagData) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get("/geo/suggestion", {
  //         params: {
  //           name: searchData,
  //           language:
  //             localStorage.getItem("setlanguage") ||
  //             localStorage.getItem("detectedlanguage") ||
  //             "en"
  //         }
  //       })
  //       .then(resp => {
  //         resolve(resp);
  //       })
  //       .catch(err => {
  //         console.log({ err });
  //         reject(err);
  //       });
  //   });
  // },
  SEARCH_GEO_SUGGESTION({ commit }, searchData) {
    return new Promise((resolve, reject) => {
      if (searchData == "" || !searchData) {
        return resolve({ data: [] });
      }
      axios
        .get("/geo/suggestion", {
          params: {
            name: searchData,
            language:
              localStorage.getItem("setlanguage") ||
              localStorage.getItem("detectedlanguage") ||
              "en"
          }
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          console.log({ err });
          reject(err);
        });
    });
  },
  SEARCH_TAG_SUGGESTION({ commit }, searchData) {
    return new Promise((resolve, reject) => {
      axios
        .get("/tag/suggestion", {
          params: {
            name: searchData,
            language:
              localStorage.getItem("setlanguage") ||
              localStorage.getItem("detectedlanguage") ||
              "en"
          }
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          console.log({ err });
          reject(err);
        });
    });
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
